import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';

import { AccountService } from '@core/services/admin/account.service';
import { APP_SLUGS, MAIN_SLUGS, SETTINGS_SLUGS } from '@routes/routes.types';

/**
 * KAN-253 — the API-keys section only exists when the account has the public API
 * contracted (`subscription.api`). Reads the account the panel already loads; no
 * extra request. Without the flag, fall back to the account page.
 */
export const apiAccessGuard: CanActivateFn = () => {
    const accountS = inject(AccountService);
    const router = inject(Router);

    return toObservable(accountS.account).pipe(
        filter(account => !!account),
        take(1),
        map(
            account =>
                !!account?.subscription?.api ||
                router.parseUrl(
                    `/${APP_SLUGS.MAIN}/${MAIN_SLUGS.SETTINGS}/${SETTINGS_SLUGS.account}`
                )
        )
    );
};
